import SportSpin from './sportspin';

export default SportSpin;
